import { useAccountContext } from '@/store/contexts/AccountContext'

/**
 * Account 관련 Custom Hook
 * AccountContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useAccount() {
  return useAccountContext()
}

